<template>
  <div>
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="6">
          <div class="leftpanel">
            <div>客户用户组列表:</div> <br/>
            <el-tree
              class="filter-tree"
              :data="u_usergroupsdata"
              :props="defaultProps"
              default-expand-all
              :expand-on-click-node="false"
              :render-content="renderugcontext">
            </el-tree>
            <div class="desinfo"> *选取用户组，添加/编辑该用户组用户</div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="rightpanel">
            <el-table
              stripe
              :data="query_u_data"
              ref="multipleTable">
              <el-table-column
                min-width="30px"
                prop="id.Int64"
                label="编号"
              >
              </el-table-column>
              <el-table-column
                prop="name.String"
                label="姓名">
              </el-table-column>
              <el-table-column
                prop="post.String"
                label="职务">
              </el-table-column>
              <el-table-column
                prop="phone.String"
                label="联系方式">
              </el-table-column>
              <el-table-column
                label="操作"
                min-width="50px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="查看/编辑该用户" placement="top-start">
                    <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="seeuser(scope.row)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除该用户" placement="top-start">
                    <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="deluser(scope.row)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="tbdownbtn">
              <div>
                <el-button @click="add_user">添加用户</el-button>
              </div>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="用户信息" :visible.sync="dialogUserFormVisible">
      <div class="showuserinfo">
        <div class="txtpanel">当前用户组：{{ curusergroup }}</div>
      <el-form :model="form" label-width="150px">
        <el-form-item label="姓名">
          <el-input  v-model="s_name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="s_nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="s_post" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="s_phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="s_email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="上传头像" class="yyzz_upload">
          <el-upload
            class="avatar-uploader"
            drag
            action="https://api.sqnetsoft.cn/ossupload/uploadoss"
            :data="{'bucketname':'newkaisuopath','bucketpath':'testpath'}"
            :on-success="OnTxSuccess"
            :on-error="OnTxError"
            :before-upload="BeforeTxUpload">
            <img v-if="tximgurlok" :src="tximgurl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      </div>
      <div class="savecususerpanel">
        <el-button @click="add_user_info">添加用户</el-button>
        <el-button @click="save_user_info">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'CusUsersGroups',
  beforeCreate: function () {
    console.log('开始创建')
    let loadingInstance1 = Loading.service({ fullscreen: true })
    that = this
    var cusinfo = JSON.parse(localStorage.getItem('cusinfo'))
    if (cusinfo === null) {
      console.log('开始读取网络数据')
      console.log(this)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {'String': 'id>0', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            loadingInstance1.close()
            localStorage.setItem('cusinfo', JSON.stringify(res.data.data))
            that.mydata = JSON.parse(localStorage.getItem('cusinfo'))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    } else {
      console.log('从本地读取')
      var cusinfostate = localStorage.getItem('cusinfostate')
      if (cusinfostate === '0') {
        that.$message({
          type: 'info',
          message: '您上次保存失败，请重新保存！'
        })
      }
      that.mydata = JSON.parse(localStorage.getItem('cusinfo'))
    }
  },
  mounted: function () {
    let loadingInstance1 = Loading.service({ fullscreen: true })
    var menudata = this.$parent.$children[1].$refs.menu_data
    console.log(menudata)
    menudata.activeIndex = '114'
    var v = getCookie('cusid')
    this.khid = v
    if (that.khid === null) {
      loadingInstance1.close()
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      if (v === '1') {
        this.showcuslist = false
        loadingInstance1.close()
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
          method: 'post',
          data: {
            cusid: parseInt(v),
            parentid: -1
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            loadingInstance1.close()
            console.log(JSON.parse(res.data.data))
            if (res.data.success) {
              that.u_usergroupsdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        this.showcuslist = true
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
          method: 'post',
          data: {
            cusid: parseInt(v),
            parentid: -1
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            loadingInstance1.close()
            console.log(JSON.parse(res.data.data))
            if (res.data.success) {
              that.u_usergroupsdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
    console.log(this.showcuslist)
  },
  data () {
    return {
      query_u_cusname: '',
      query_u_cusno: '',
      query_u_cusdata: [],
      u_usergroupsdata: [],
      query_u_data: [],
      curusergroup: '',
      curuserid: '',
      curgroupid: '',
      showcuslist: true,
      tx_path: '',
      s_name: '',
      s_nickname: '',
      s_post: '',
      s_phone: '',
      s_email: '',
      tximgurlok: false,
      tximgurl: '',
      dialogUserFormVisible: false,
      khid: 0,
      selectusergroupnode: [],
      defaultProps: {
        children: 'Children',
        label: 'Name'
      }
    }
  },
  methods: {
    renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.Name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.showuser(node, data)}> </i>
          </span>
        </span>
      )
    },
    query_cus () {
      console.log(this.query_u_cusname)
      console.log(this.query_u_cusno)
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var qstr = 'ownerid =' + this.khid
      if (this.query_u_cusname !== null && this.query_u_cusname !== '') {
        qstr = qstr + " and name like '%" + this.query_u_cusname + "%' "
      }
      if (this.query_u_cusno !== null && this.query_u_cusno !== '') {
        qstr = qstr + " and bl_num like '%" + this.query_u_cusno + "%'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          limit: {String: 'limit 2', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.query_u_cusdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeusergroup (row) {
      console.log(row.id)
      let loadingInstance1 = Loading.service({ fullscreen: true })
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
        method: 'post',
        data: {
          cusid: parseInt(row.id),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          loadingInstance1.close()
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.u_usergroupsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    showuser (node, data) {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(node)
      console.log(data.Level)
      this.s_email = ''
      this.s_name = ''
      this.s_nickname = ''
      this.s_post = ''
      this.s_phone = ''
      this.tximgurlok = false
      this.selectusergroupnode = data
      this.curusergroup = data.Name
      var sqlstr = 'usergroups_id = ' + data.Id + ' and cus_id = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcususer',
        method: 'post',
        data: {
          whereinfo: {String: sqlstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          loadingInstance1.close()
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.query_u_data = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeuser (row) {
      console.log('查看用户')
      console.log(row)
      this.dialogUserFormVisible = true
      this.s_email = row.email.String
      this.s_name = row.name.String
      this.s_nickname = row.nickname.String
      this.s_post = row.post.String
      this.s_phone = row.phone.String
      this.curgroupid = row.usergroupid
      this.curuserid = row.id.Int64
      if (row.imgurl.Valid && row.imgurl.String !== '') {
        this.tximgurlok = true
        this.tximgurl = row.imgurl.String
      } else {
        this.tximgurlok = false
      }
    },
    deluser (row) {
      console.log('删除用户')
      console.log(row)
      console.log(row.id.Int64)
      let loadingInstance1 = Loading.service({ fullscreen: true })
      var sqlstr = 'id = ' + row.id.Int64
      var subsqlstr = 'usergroups_id = ' + row.usergroupid + ' and cus_id = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/delcususer',
        method: 'post',
        data: {
          whereinfo: {String: sqlstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getcususer',
              method: 'post',
              data: {
                whereinfo: {String: subsqlstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                console.log(JSON.parse(res.data.data))
                loadingInstance1.close()
                if (res.data.success) {
                  that.query_u_data = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    add_user () {
      if (this.selectusergroupnode.length !== 0) {
        this.dialogUserFormVisible = true
        console.log(this.selectusergroupnode)
      } else {
        that.$message({
          type: 'info',
          message: '请先选择部门/子公司!'
        })
      }
    },
    add_user_info () {
      console.log(this.selectusergroupnode)
      console.log(this.tx_path)
      console.log(this.s_name)
      console.log(this.s_nickname)
      console.log(this.s_post)
      console.log(this.s_phone)
      console.log(this.s_email)
      let loadingInstance1 = Loading.service({ fullscreen: true })
      if (this.selectusergroupnode) {
        var oldobj = {
          cusid: parseInt(this.khid),
          usergroupid: parseInt(this.selectusergroupnode.Id),
          name: {String: this.s_name, Valid: true},
          nickname: {String: this.s_nickname, Valid: true},
          post: {String: this.s_post, Valid: true},
          phone: {String: this.s_phone, Valid: true},
          email: {String: this.s_email, Valid: true},
          imgurl: {String: this.tx_path, Valid: true}
        }
        var sqlstr = 'usergroups_id = ' + this.selectusergroupnode.Id + ' and cus_id = ' + this.khid
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcususer',
          method: 'post',
          data: oldobj,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(res.data.data)
              that.$http({
                url: 'https://api.sqnetsoft.cn/customer/getcususer',
                method: 'post',
                data: {
                  whereinfo: {String: sqlstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  console.log(res)
                  loadingInstance1.close()
                  console.log(JSON.parse(res.data.data))
                  if (res.data.success) {
                    that.dialogUserFormVisible = false
                    that.query_u_data = JSON.parse(res.data.data)
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    save_user_info () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.selectusergroupnode)
      var oldobj = {
        id: {Int64: this.curuserid, Valid: true},
        cusid: parseInt(this.khid),
        usergroupid: parseInt(this.curgroupid),
        name: {String: this.s_name, Valid: true},
        nickname: {String: this.s_nickname, Valid: true},
        post: {String: this.s_post, Valid: true},
        phone: {String: this.s_phone, Valid: true},
        email: {String: this.s_email, Valid: true}
      }
      var sqlstr = 'usergroups_id = ' + this.selectusergroupnode.Id + ' and cus_id = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/addcususer',
        method: 'post',
        data: oldobj,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(res.data.data)
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getcususer',
              method: 'post',
              data: {
                whereinfo: {String: sqlstr, Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                loadingInstance1.close()
                console.log(JSON.parse(res.data.data))
                if (res.data.success) {
                  that.dialogUserFormVisible = false
                  that.query_u_data = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '添加成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    BeforeTxUpload (file) {
    },
    OnTxError (res) {
      console.log(res)
    },
    OnTxSuccess (res, file, fileList) {
      console.log(res.success)
      if (res.success) {
        that.tx_path = res.data[0].osspath
        this.tximgurlok = true
        this.tximgurl = res.data[0].osspath
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style lang="css">
  .querypanel {
    margin-top: 10px;
    border: 1px solid #ebebeb;
    padding: 20px;
    border-radius: 3px;
    transition: .2s;
  }
  .oppanel {
    margin-top: 10px;
    border: 1px solid #ebebeb;
    padding: 20px;
    border-radius: 3px;
    height: 100px;
    transition: .2s;
  }
  .tablepanel {
    margin-top: 10px;
    margin-bottom: 20px;
    border: 1px solid #ebebeb;
    padding: 30px;
    border-radius: 3px;
    transition: .2s;
  }
  .querybtn {
    padding-left: 10px;
  }
  .desinfo {
    margin-top: 10px;
    font-size: 8px;
  }
  .leftpanel {
  }
  .rightpanel {
    padding-left: 20px;
  }
  .savebtnpanel {
    margin-top: 20px;
  }
  .showuserinfo {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
  }
  .tabcard {
    padding-top: 20px;
  }

  .el-dialog__body {
    margin: 10px 20px 10px 20px;
    padding: 20px 30px;
    color: #f1f1f1;
    line-height: 24px;
    font-size: 14px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
  }

  .el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item1 {
    margin-bottom: 0px;
  }

  .el-form-item__label {
    text-align: left;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #5a5e66;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__footer {
    padding: 10px 10px 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__header {
    padding: 15px 15px 10px;
    background-color: #0d8ddb;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #f0f0f0;
  }

  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
    box-sizing: border-box;
    width: 80%;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 180px;
    height: 180px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }
  .txtpanel {
    margin-top: 10px;
    margin-bottom: 20px;
    color: #007ee5;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .savecususerpanel {
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cus/CusUsers.vue